const SESSION_EXPIRY_KEY = "sessionExpired";

export const markSessionExpired = () => {
  sessionStorage.setItem(SESSION_EXPIRY_KEY, "1");
};

export const consumeSessionExpired = () => {
  const isExpired = sessionStorage.getItem(SESSION_EXPIRY_KEY) !== null;

  if (isExpired) {
    sessionStorage.removeItem(SESSION_EXPIRY_KEY);
  }

  return isExpired;
};
